<template>
	<div class="index-container">

		<div class="search" style="border-bottom:1px solid #dcdfe6;padding:10px 0">
			<el-form ref="form" :model="form">
				<el-form-item label="商场名称">
					<el-select collapse-tags @change="mallSelect" v-model="form.mallIds" placeholder="全部" multiple>
						<el-option v-for="item in mallList" :label="item.name" :value="item.id"
							:key="item.id"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>

		<div class="title-box">
			<div class="title-left"></div>
			<div class="title">会员数据</div>
		</div>
		<div class="finance-div">
			<div v-for="(item, index) in VipData" :key="index" :class="'finance'">
				<div class="dataItem" v-for="(dataItem, itemIndex) in item.itemArr" :key="itemIndex">
					<img :src="dataItem.icon" class="dataItem-img">
					<div class="dataItem-content">
						<p class="dataItem-title">{{dataItem.title}}</p>
						<p class="dataItem-value">{{dataItem.amount}}</p>
					</div>
					<el-divider v-if="(item.itemArr.length - 1) != itemIndex" direction="vertical"></el-divider>
				</div>
			</div>
		</div>
		<div class="title-box">
			<div class="title-left"></div>
			<div class="title">会员新增统计</div>
		</div>
		<el-row>
			<el-col :span="24">
				<div class="charts1" ref="chartE1"></div>
			</el-col>
		</el-row>
		<div class="title-box">
			<div class="title-left"></div>
			<div class="title">交易数据</div>
		</div>
		<div class="finance-div">
			<div v-for="(item, index) in transactionData" :key="index"
				:class="index == 0 ?  'finance first financeBig' : 'finance financeBig'">
				<div class="dataItem" v-for="(dataItem, itemIndex) in item.itemArr" :key="itemIndex">
					<img :src="dataItem.icon" class="dataItem-img">
					<div class="dataItem-content">
						<p class="dataItem-title">
							{{dataItem.title}}
							<el-tooltip content="包含退款金额" placement="bottom" effect="light">
								<i v-if="dataItem.key == 'totalTradeAmount'" class="tipsB el-icon-question"></i>
							</el-tooltip>
							<el-tooltip content="包含退款金额" placement="bottom" effect="light">
								<i v-if="dataItem.key == 'todayTradeAmount'" class="tipsB el-icon-question"></i>
							</el-tooltip>
						</p>
						<p class="dataItem-value">{{dataItem.amount}}<span></span></p>
					</div>
					<el-divider v-if="(item.itemArr.length - 1) != itemIndex" direction="vertical"></el-divider>
				</div>
			</div>
		</div>
		<div class="title-box">
			<div class="title-left"></div>
			<div class="title">交易概况 TOP30</div>
		</div>
		<el-row>
			<el-col :span="24">
				<div class="radio-change">
					<el-radio-group @input="getDashboardTradeCountChart" v-model="timeDiff">
						<el-radio :label="1">昨日交易</el-radio>
						<el-radio :label="0">当日交易</el-radio>
					</el-radio-group>
				</div>
				<div v-loading="loading2" class="charts1 height500" ref="chartE2"></div>
				<div v-loading="loading2" v-if="empty1" class="empty1 empty">
					<span class="empty-content">未产生交易，暂无数据...</span>
				</div>
			</el-col>
		</el-row>
		<div class="title-box">
			<div class="title-left"></div>
			<div class="title">30天累计交易金额</div>
		</div>
		<el-row>
			<el-col :span="24">
				<div v-loading="loading3" :class="'charts1'" ref="chartE3"></div>
				<div v-loading="loading3" v-if="empty" class="empty">
					<span class="empty-title">交易TOP5</span>
					<span class="empty-content">未产生交易，暂无数据...</span>
				</div>
			</el-col>
		</el-row>

		<data-ranking :mallIds="form.mallIds"></data-ranking>
	</div>
</template>

<script>
	import {
		api_getDashboardMemberData,
		api_getDashboardMemberChart,
		api_getDashboardTradeData,
		api_getDashboardTradeCountChart,
		api_getDashboardTradeAmountChart
	} from '@/api/home'
	import {
		api_getConfig
	} from "@/api/common";
	import * as echarts from 'echarts';
	import DataRanking from "@/views/components/DataRanking"
	export default {
		name: 'Index',
		components: {
			DataRanking
		},
		data() {
			return {
				form: {
					mallIds: []
				},
				empty: false,
				empty1: false,
				VipData: [{
					itemArr: [{
						title: '累计会员人数（人）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_12.png"),
						company: '人',
						key: 'totalCount'
					}, {
						title: '今日交易会员（人）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_13.png"),
						company: '人',
						key: 'tradeCount'
					}, {
						title: '今日新增会员（人）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_14.png"),
						company: '人',
						key: 'newCount'
					}]
				}],
				transactionData: [{
					itemArr: [{
						title: '总交易额（元）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_7.png"),
						company: '元',
						key: 'totalTradeAmount'
					}, {
						title: '净成交总额（元）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_15.png"),
						company: '元',
						key: 'totalRetainedDealAmount'
					}, {
						title: '总退款金额（元）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_3.png"),
						company: '元',
						key: 'totalRefundAmount'
					}, {
						title: '总交易笔数（笔）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_1.png"),
						company: '笔',
						key: 'totalTradeCount'
					}, {
						title: '总退款笔数（笔）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_17.png"),
						company: '笔',
						key: 'totalRefundCount'
					}]
				}, {
					itemArr: [{
						title: '今日交易额（元）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_2.png"),
						company: '元',
						key: 'todayTradeAmount'
					}, {
						title: '今日净交易额（元）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_16.png"),
						company: '元',
						key: 'todayRetainedDealAmount'
					}, {
						title: '今日退款金额（元）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_3.png"),
						company: '元',
						key: 'todayRefundAmount'
					}, {
						title: '今日交易笔数（笔）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_18.png"),
						company: '笔',
						key: 'todayTradeCount'
					}, {
						title: '今日退款笔数（笔）',
						amount: '-',
						icon: require("@/assets/finance_images/finance_17.png"),
						company: '笔',
						key: 'todayRefundCount'
					}]
				}],
				option: {
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}点 : 新增{c}人'
					},
					grid: {
						x: 60,
						y: 50,
						x2: 40,
						y2: 20,
					},
					xAxis: {
						name: '时间',
						nameLocation: 'end',
						type: 'category',
						data: [],
					},
					legend: {
						right: 0,
					},
					yAxis: {
						name: '人数',
						nameLocation: 'end',
						type: 'value',
						minInterval: 1,
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								type: 'dashed'
							}
						}
					},
					series: []
				},
				timeDiff: 0,
				option1: {
					grid: {
						x: 40,
						y: 20,
						x2: 10,
						y2: 60,
					},
					legend: {
						bottom: 0,
					},
					dataZoom: [{
						type: 'inside',
					}],
					dataset: {
						dimensions: ['name', 'amount', 'point', 'count'],
						source: []
					},
					xAxis: {
						name: '',
						type: 'category',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					yAxis: {
						name: '',
						type: 'value',
						splitNumber: 8,
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								type: 'dashed'
							}
						}
					},
					series: [{
							name: '净成交金额',
							type: 'bar',
							label: {
								show: true,
								position: 'top'
							},
							itemStyle: {
								color: 'rgba(55, 117, 255, 1)'
							}
						},
						{
							name: '积分',
							type: 'bar',
							label: {
								show: true,
								position: 'top'
							},
							itemStyle: {
								color: 'rgba(5, 200, 175, 1)'
							}
						},
						{
							name: '交易笔数',
							type: 'bar',
							label: {
								show: true,
								position: 'top'
							},
							itemStyle: {
								color: '#696969'
							}
						}
					]
				},
				option2: {
					grid: {
						x: 80,
						y: 30,
						x2: 70,
						y2: 20,
					},
					yAxis: {
						name: '交易TOP5',
						type: 'category',
						data: []
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						name: '金额（元）',
						type: 'value',
						splitLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								type: 'dashed'
							}
						}
					},
					series: [{
						name: '金额（元）',
						data: [],
						type: 'bar',
						label: {
							show: true,
							position: 'right'
						},
						itemStyle: {
							color: 'rgba(5, 200, 175, 1)'
						}
					}]
				},
				chart1: null,
				chart2: null,
				chart3: null,
				mallList: [],
				loading1: false,
				loading2: false,
				loading3: false,
			}
		},
		created() {
			/* this.getDashboardMemberData()
			this.getDashboardMemberChart()
			this.getDashboardTradeData()
			this.getDashboardTradeCountChart()
			this.getDashboardTradeAmountChart() */
			this.getConfig()
		},
		beforeDestroy() {},
		mounted() {
			window.onresize = () => {
				return (() => {
					try {
						this.chart1 = echarts.init(this.$refs.chartE1)
						this.$refs.chartE1.removeAttribute('_echarts_instance_')
						this.chart1.setOption(this.option)
					} catch (error) {}
					try {
						this.chart2 = echarts.init(this.$refs.chartE2)
						this.$refs.chartE2.removeAttribute('_echarts_instance_')
						this.chart2.setOption(this.option1)
					} catch (error) {}
					try {
						this.chart3 = echarts.init(this.$refs.chartE3)
						this.$refs.chartE3.removeAttribute('_echarts_instance_')
						this.chart3.setOption(this.option2)
					} catch (error) {}
				})()
			}
		},
		methods: {
			//会员数据商场切换
			mallSelect_member() {
				this.getDashboardMemberData()
			},
			mallSelect_memberChart() {
				this.getDashboardMemberChart()
			},
			mallSelect() {
				//会员数据
				this.getDashboardMemberData()
				//会员新增统计
				this.getDashboardMemberChart()

				this.getDashboardTradeData()
				this.getDashboardTradeCountChart()
				this.getDashboardTradeAmountChart()
			},
			// 获取config
			async getConfig() {
				const {
					storeThreeLevel = [], mall = []
				} = await api_getConfig(['mall'])
				
				this.mallList = mall // 商场
				this.form.mallIds = [];
				this.form.mallIds.push(mall[0].id)
				
				console.log('当前店铺id',this.form.mallIds)
				
				this.mallSelect();
			},
			async getDashboardMemberData() {
				const data = await api_getDashboardMemberData({
					 mallIds: this.form.mallIds
				})
				this.VipData.forEach((item) => {
					item.itemArr.forEach((v) => {
						v.amount = data[v.key]
					})
				})
			},
			async getDashboardMemberChart() {
				let data = await api_getDashboardMemberChart({
					mallIds: this.form.mallIds
				})
				console.log(data)
				let yesterdayOption = {
					data: [],
					name: '昨日',
					type: 'line',
					color: 'rgba(72, 250, 227, 1)',
					label: {
						show: true,
						position: 'top'
					},
					smooth: true
				}
				let todayOption = {
					data: [],
					name: '今日',
					type: 'line',
					color: 'rgba(153, 184, 255, 1)',
					label: {
						show: true,
						position: 'top'
					},
					smooth: true
				}
				try {
					yesterdayOption.data = data.yesterday.map((item) => {
						return item.newCount
					})
					this.option.xAxis.data = data.yesterday.map((item) => {
						return item.hour
					})
				} catch (error) {
					yesterdayOption.data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
					this.option.xAxis.data = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
						21, 22, 23
					]
				}
				try {
					todayOption.data = data.today.map((item) => {
						return item.newCount
					})
				} catch (error) {
					todayOption.data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
				}
				this.option.series = [yesterdayOption, todayOption]
				this.chart1 = echarts.init(this.$refs.chartE1)
				this.chart1.setOption(this.option)
			},
			async getDashboardTradeData() {
				this.loading1 = true
				let data = await api_getDashboardTradeData({
					mallIds: this.form.mallIds
				})
				this.loading1 = false
				this.transactionData.forEach((item) => {
					item.itemArr.forEach((v) => {
						v.amount = data[v.key]
					})
				})
			},
			async getDashboardTradeCountChart() {
				this.loading2 = true
				let data = await api_getDashboardTradeCountChart({
					mallIds: this.form.mallIds,
					timeDiff: this.timeDiff
				})
				this.loading2 = false
				console.log(data)
				this.chart2 = echarts.init(this.$refs.chartE2)
				try {
					this.option1.dataset.source = data
					if (data.length <= 0) {
						this.empty1 = true
						this.chart2.dispose()
						return
					}
					this.empty1 = false
				} catch (error) {
					this.empty1 = true
					this.chart2.dispose()
				}
				this.$refs.chartE2.removeAttribute('_echarts_instance_')
				this.chart2.setOption(this.option1)
			},
			async getDashboardTradeAmountChart() {
				this.loading3 = true
				let data = await api_getDashboardTradeAmountChart({
					mallIds: this.form.mallIds
				})
				this.loading3 = false
				this.chart3 = echarts.init(this.$refs.chartE3)
				try {
					data.sort(this.sortBy('amount', 'asc'))
					this.option2.yAxis.data = data.map((item) => {
						return item.category
					})
					this.option2.series[0].data = data.map((item) => {
						return item.amount || 0
					})
					if (data.length <= 0) {
						this.empty = true
						this.chart3.dispose()
						return
					}
					this.empty = false
					try {
						this.$refs.chartE3.removeAttribute('_echarts_instance_')
					} catch (error) {

					}
					this.chart3.setOption(this.option2)
				} catch (error) {
					console.log(error)
					this.empty = true
					this.chart3.dispose()
				}
			},
			sortBy(name, sort) {
				return function(o, p) {
					var a, b;
					if (typeof o === "object" && typeof p === "object" && o && p) {
						a = parseInt(o[name]);
						b = parseInt(p[name]);
						if (a === b) {
							return 0;
						}
						if (sort == 'asc') {
							if (typeof a === typeof b) {
								return a < b ? -1 : 1;
							}
							return typeof a < typeof b ? -1 : 1;
						} else {
							if (typeof a === typeof b) {
								return a > b ? -1 : 1;
							}
							return typeof a > typeof b ? -1 : 1;
						}
					} else {
						throw ("error");
					}
				}
			}
		},
	}
</script>
<style lang="scss" scoped>
	.index-container {
		padding: 0 20px;
		padding-top: 5px;
		padding-bottom: 20px;

		.title-box {
			margin-top: 30px;
			margin-bottom: 30px;
			display: flex;
			align-items: center;

			.title-left {
				width: 5px;
				height: 25px;
				background: #05C8AF;
				border-radius: 2px;
			}

			.title {
				font-size: 18px;
				font-weight: 600;
				color: #333333;
				margin-left: 10px;
			}
		}

		.finance.first {
			// border-top: 0;
			margin-bottom: 20px;
		}

		.finance {
			height: 100px;
			border-top: 1px solid #dcdfe6;
			border-bottom: 1px solid #dcdfe6;
			box-sizing: border-box;
			display: flex;
			// min-width: 1150px;
		}

		.financeBig {
			min-width: 1223px;
		}

		.finance-div {
			// min-width: 1160px;
			overflow: auto;
		}

		*::-webkit-scrollbar {
			/*滚动条整体样式*/
			width: 4px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 5px;
		}

		*::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
			background: #dcdfe6;
		}

		*::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
			border-radius: 10px;
			background: #fafafa;
		}

		.dataItem {
			// border-top: 1px solid #dcdfe6;
			// border-bottom: 1px solid #dcdfe6;
			width: 250px;
			flex-shrink: 0;
			display: flex;
			align-items: center;

			img {
				width: 40px;
				height: 40px;
				margin-left: 30px;
			}

			.dataItem-content {
				margin-left: 10px;
				width: 174px;

				.dataItem-title {
					font-size: 12px;
					color: #666666;
					margin: 0;
					margin-bottom: 10px;
				}

				.dataItem-value {
					font-size: 20px;
					font-weight: 500;
					color: #333333;
					margin: 0;

					span {
						font-size: 12px;
						font-weight: 400;
						color: #666666;
						margin-left: 10px;
					}
				}
			}

			::v-deep {
				.el-divider--vertical {
					height: 70px;
				}
			}
		}

		.radio-change {
			text-align: right;
		}

		.charts1 {
			width: 100%;
			height: 300px;
		}

		.height500 {
			height: 500px;
		}

		.charts2 {
			height: 0;
			position: relative;
		}

		.tipsB {
			font-size: 13px;
			color: #999;
		}

		.empty {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;

			.empty-title {
				font-size: 14px;
				color: #333333;
				display: block;
			}

			.empty-content {
				font-size: 18px;
				font-weight: 400;
				color: #999999;
				line-height: 280px;
				display: block;
				text-align: center;
			}

			height: 300px;
		}

		.empty1 {
			height: 500px;
			top: 20px;

			.empty-content {
				line-height: 500px;
			}
		}
	}
</style>